// Demon style - dark, demonic, hellish names
export const demonPrefixes = [
    "Abad", "Ash", "Bael", "Bel", "Carn", "Dar", "Drak", "Fel", "Grim", "Hel",
    "Inf", "Kar", "Kor", "Mal", "Mor", "Nec", "Nyx", "Raz", "Sab", "Shade",
    "Syn", "Tar", "Torm", "Vex", "Void", "Wraith", "Xar", "Zar", "Zer", "Zorn",
    "Ash", "Blood", "Bone", "Crypt", "Death", "Doom", "Dread", "Ebon", "Ghost", "Grave",
    "Havoc", "Hex", "Hollow", "Maleg", "Night", "Omen", "Phan", "Raven", "Scourge", "Shadow"
];

export const demonSuffixes = [
    "amon", "ar", "ax", "bane", "born", "claw", "daemon", "deth", "dor", "el",
    "eth", "fall", "fang", "fire", "flame", "gore", "grim", "hell", "horn", "ion",
    "is", "ith", "ix", "lash", "lock", "lor", "mire", "moth", "nox", "oth",
    "phyre", "rend", "rix", "rot", "shade", "sin", "spawn", "spike", "thorn", "tor",
    "us", "vane", "void", "wrath", "wretch", "xis", "zar", "zel", "zor", "zul"
];

export const trDemonPrefixes = [
    "Azaz", "Zebun", "Cin", "İfrit", "Kar", "Zul", "Mel", "Lan", "Şey", "Hort",
    "Kan", "Kemik", "Kabir", "Ölüm", "Kara", "Kus", "Karan", "Alev", "Gölge", "Mezar",
    "Felaket", "Büyü", "Boş", "Gece", "Uğur", "Karga", "Bela", "Ruh", "Nefret", "Ateş"
];

export const trDemonSuffixes = [
    "azel", "el", "göz", "pençe", "diş", "kan", "ateş", "alev", "kabir", "kuyu",
    "han", "şah", "can", "ruh", "kara", "karanlık", "ölüm", "boğan", "yakan", "kesen",
    "kıran", "yutan", "gören", "bilen", "süren", "kuran", "yıkman", "bozan", "saçan", "bulan"
];

export const frDemonPrefixes = [
    "Abad", "Cendre", "Bael", "Bel", "Carn", "Dar", "Drak", "Fel", "Grim", "Hel",
    "Inf", "Kar", "Kor", "Mal", "Mor", "Nec", "Nyx", "Raz", "Sab", "Ombre",
    "Syn", "Tar", "Torm", "Vex", "Vide", "Spectre", "Xar", "Zar", "Zer", "Zorn",
    "Cendre", "Sang", "Os", "Crypte", "Mort", "Destin", "Terreur", "Ebon", "Fantôme", "Tombe",
    "Ravage", "Sort", "Creux", "Maleg", "Nuit", "Présage", "Phan", "Corbeau", "Fléau", "Ombre"
];

export const frDemonSuffixes = [
    "amon", "ar", "ax", "bane", "né", "griffe", "démon", "mort", "dor", "el",
    "eth", "chute", "croc", "feu", "flamme", "gore", "grim", "enfer", "corne", "ion",
    "is", "ith", "ix", "fouet", "serrure", "lor", "bourbier", "mite", "nox", "oth",
    "phyre", "déchire", "rix", "pourri", "ombre", "péché", "rejeton", "pointe", "épine", "tor",
    "us", "pale", "vide", "colère", "misérable", "xis", "zar", "zel", "zor", "zul"
];


// Slasher style - horror movie character names
export const slasherPrefixes = [
    "Blade", "Blood", "Bone", "Butch", "Carv", "Chain", "Claw", "Cleav", "Cold", "Creep",
    "Crypt", "Cut", "Dark", "Dead", "Doom", "Dread", "Edge", "Face", "Fear", "Flesh",
    "Gore", "Grim", "Hack", "Hook", "Hunt", "Jack", "Kill", "Knife", "Lurk", "Mask",
    "Mid", "Murder", "Night", "Pain", "Pale", "Razor", "Rip", "Scar", "Scream", "Shade",
    "Shadow", "Slay", "Slash", "Slice", "Stalk", "Terror", "Vile", "Whisper", "Wound", "Wraith"
];

export const slasherSuffixes = [
    "axe", "blade", "blood", "bone", "born", "bringer", "claw", "cleaver", "crypt", "cut",
    "death", "doom", "dread", "edge", "face", "fang", "fear", "flesh", "ghost", "gore",
    "grim", "hack", "hand", "haunt", "heart", "hook", "hunt", "kill", "knife", "lurk",
    "man", "mask", "night", "pain", "reaper", "rend", "ripper", "scar", "scream", "shade",
    "shadow", "slash", "slayer", "stalk", "stalker", "terror", "tooth", "walker", "whisper", "wound"
];

export const trSlasherPrefixes = [
    "Bıçak", "Kan", "Kemik", "Kasap", "Zincir", "Pençe", "Satır", "Soğuk", "Ürperti",
    "Mezar", "Kesik", "Karanlık", "Ölü", "Kıyamet", "Korku", "Et",
    "Vahşet", "Gaddar", "Çengel", "Avcı", "Katil", "Jilet", "Sinsi", "Maske",
    "Gece", "Acı", "Solgun", "Yara", "Çığlık", "Gölge"
];

export const trSlasherSuffixes = [
    "bıçak", "kan", "kemik", "getiren", "pençe", "satır", "mezar", "kesen",
    "ölüm", "kıyamet", "korku", "yüz", "diş", "et", "hayalet",
    "el", "kalp", "çengel", "avcı", "katil", "jilet", "sinsi",
    "adam", "maske", "gece", "acı", "biçen", "yara", "çığlık", "gölge",
    "kesen", "avlayan", "takipçi", "diş", "yürüyen", "fısıltı"
];

export const frSlasherPrefixes = [
    "Lame", "Sang", "Os", "Boucher", "Chaîne", "Griffe", "Couperet", "Froid", "Ramper",
    "Crypte", "Coupe", "Sombre", "Mort", "Destin", "Effroi", "Tranchant", "Visage", "Peur", "Chair",
    "Gore", "Sombre", "Hache", "Crochet", "Chasse", "Jack", "Tuer", "Couteau", "Rôde", "Masque",
    "Minuit", "Meurtre", "Nuit", "Douleur", "Pâle", "Rasoir", "Déchire", "Cicatrice", "Cri", "Ombre",
    "Ombre", "Tuer", "Entaille", "Tranche", "Traque", "Terreur", "Vil", "Murmure", "Blessure", "Spectre"
];

export const frSlasherSuffixes = [
    "hache", "lame", "sang", "os", "né", "porteur", "griffe", "couperet", "crypte", "coupe",
    "mort", "destin", "effroi", "tranchant", "visage", "croc", "peur", "chair", "fantôme", "gore",
    "sombre", "hache", "main", "hante", "cœur", "crochet", "chasse", "tuer", "couteau", "rôde",
    "homme", "masque", "nuit", "douleur", "faucheur", "déchire", "éventreur", "cicatrice", "cri", "ombre",
    "ombre", "entaille", "tueur", "traque", "traqueur", "terreur", "dent", "marcheur", "murmure", "blessure"
];

// Cosmic Horror style - Lovecraftian, eldritch names
export const cosmicPrefixes = [
    "Ath", "Azag", "Azath", "Cth", "Dagon", "Eldr", "Gla", "Hastur", "Hyd", "Iod",
    "Kthu", "Lloi", "Loth", "Maal", "Mgla", "Noth", "Nyl", "Oth", "Phao", "Rlyeh",
    "Shog", "Soth", "Thog", "Tsath", "Ubbo", "Ubb", "Umr", "Vhoor", "Xoth", "Yig",
    "Yog", "Zhar", "Zoth", "Abhor", "Chaos", "Deep", "Elder", "Eter", "Hollow", "Mad",
    "Nameless", "Outer", "Star", "Stellar", "Stygian", "Void", "Warp", "Xeno", "Yonder", "Zerou"
];

export const cosmicSuffixes = [
    "ath", "gor", "goth", "hoth", "hulhu", "igor", "lor", "loth", "moth", "nath",
    "ogtha", "oth", "rath", "roth", "shub", "soth", "thog", "thoth", "thulhu", "uth",
    "ygr", "yll", "zoth", "born", "caller", "crawler", "creep", "dweller", "eater", "entity",
    "form", "gaze", "horror", "lurker", "maw", "mouth", "one", "presence", "seeker", "shadow",
    "spawn", "stalker", "thing", "thirst", "touch", "void", "walker", "watcher", "whisper", "wyrm"
];

// Use same cosmic names for other languages as they are mostly alien/universal (Lovecraftian)
export const trCosmicPrefixes = cosmicPrefixes;
export const trCosmicSuffixes = cosmicSuffixes;
export const frCosmicPrefixes = cosmicPrefixes;
export const frCosmicSuffixes = cosmicSuffixes;

// Spanish Horror Names
export const esDemonPrefixes = [
    "Abisal", "Ceniza", "Bael", "Bel", "Carn", "Oscur", "Drak", "Mal", "Sombr", "Infern",
    "Kar", "Kor", "Maldit", "Mort", "Necr", "Nyx", "Raz", "Diabl", "Tiniebla", "Penumbr",
    "Sangr", "Hues", "Cript", "Muert", "Perdi", "Pavor", "Ebon", "Espect", "Tumb", "Llam"
];

export const esDemonSuffixes = [
    "amon", "ar", "ax", "bane", "garra", "demonio", "muerte", "dor", "el",
    "eth", "caída", "colmillo", "fuego", "llama", "gore", "grim", "infierno", "cuerno", "ion",
    "is", "ith", "ix", "azote", "lor", "ciénaga", "nox", "oth",
    "phyre", "desgarro", "rix", "podre", "sombra", "pecado", "engendro", "espina", "tor",
    "us", "vano", "vacío", "ira", "maldito", "xis", "zar", "zel", "zor", "zul"
];

export const esSlasherPrefixes = [
    "Cuchilla", "Sangre", "Hueso", "Carnicero", "Cadena", "Garra", "Hacha", "Frío", "Cripta",
    "Corte", "Oscuro", "Muerto", "Condena", "Pavor", "Filo", "Rostro", "Miedo", "Carne",
    "Macabro", "Gancho", "Cazador", "Asesino", "Cuchillo", "Acecho", "Máscara",
    "Medianoche", "Noche", "Dolor", "Pálido", "Navaja", "Cicatriz", "Grito", "Sombra"
];

export const esSlasherSuffixes = [
    "hacha", "filo", "sangre", "hueso", "garra", "cripta", "corte",
    "muerte", "condena", "pavor", "rostro", "colmillo", "miedo", "carne", "fantasma",
    "mano", "corazón", "gancho", "cazador", "asesino", "cuchillo", "acecho",
    "máscara", "noche", "dolor", "segador", "destripador", "cicatriz", "grito", "sombra"
];

export const esCosmicPrefixes = cosmicPrefixes;
export const esCosmicSuffixes = cosmicSuffixes;

// German Horror Names
export const deDemonPrefixes = [
    "Asche", "Blut", "Knochen", "Gruft", "Tod", "Dunkel", "Schreck", "Ebon", "Geist", "Grab",
    "Höll", "Hex", "Hohl", "Malef", "Nacht", "Omen", "Phantom", "Raben", "Plag", "Schatten",
    "Abgrund", "Bael", "Bel", "Carn", "Drak", "Fel", "Grim", "Hel", "Infern", "Mal"
];

export const deDemonSuffixes = [
    "amon", "ar", "bann", "klaue", "dämon", "tod", "dor", "el",
    "eth", "fall", "fang", "feuer", "flamme", "blut", "grimm", "hölle", "horn", "ion",
    "is", "ith", "ix", "geißel", "lor", "sumpf", "nox", "oth",
    "phyr", "riss", "rix", "fäule", "schatten", "sünde", "brut", "dorn", "tor",
    "us", "blass", "leere", "zorn", "elend", "xis", "zar", "zel", "zor", "zul"
];

export const deSlasherPrefixes = [
    "Klinge", "Blut", "Knochen", "Metzger", "Kette", "Klaue", "Beil", "Kalt", "Gruft",
    "Schnitt", "Dunkel", "Tot", "Verhängnis", "Grauen", "Scharf", "Gesicht", "Furcht", "Fleisch",
    "Grausam", "Haken", "Jäger", "Mörder", "Messer", "Lauer", "Maske",
    "Mitternacht", "Nacht", "Schmerz", "Bleich", "Klinge", "Narbe", "Schrei", "Schatten"
];

export const deSlasherSuffixes = [
    "axt", "klinge", "blut", "knochen", "klaue", "gruft", "schnitt",
    "tod", "verhängnis", "grauen", "gesicht", "fang", "furcht", "fleisch", "geist",
    "hand", "herz", "haken", "jäger", "mörder", "messer", "lauer",
    "maske", "nacht", "schmerz", "schnitter", "schlitzer", "narbe", "schrei", "schatten"
];

export const deCosmicPrefixes = cosmicPrefixes;
export const deCosmicSuffixes = cosmicSuffixes;

// Portuguese Horror Names
export const ptDemonPrefixes = [
    "Cinza", "Sangue", "Osso", "Cripta", "Morte", "Trevas", "Pavor", "Ebon", "Fantasma", "Tumba",
    "Infern", "Maldição", "Oco", "Malig", "Noite", "Presságio", "Espectro", "Corvo", "Flagelo", "Sombra",
    "Abism", "Bael", "Bel", "Carn", "Drak", "Fel", "Grim", "Hel", "Kar", "Mal"
];

export const ptDemonSuffixes = [
    "amon", "ar", "ax", "bane", "garra", "demônio", "morte", "dor", "el",
    "eth", "queda", "presa", "fogo", "chama", "gore", "grim", "inferno", "chifre", "ion",
    "is", "ith", "ix", "açoite", "lor", "pântano", "nox", "oth",
    "phyre", "rasgo", "rix", "podre", "sombra", "pecado", "cria", "espinho", "tor",
    "us", "pálido", "vazio", "fúria", "maldito", "xis", "zar", "zel", "zor", "zul"
];

export const ptSlasherPrefixes = [
    "Lâmina", "Sangue", "Osso", "Açougueiro", "Corrente", "Garra", "Cutelo", "Frio", "Cripta",
    "Corte", "Sombrio", "Morto", "Perdição", "Pavor", "Afiado", "Face", "Medo", "Carne",
    "Macabro", "Gancho", "Caçador", "Assassino", "Faca", "Espreita", "Máscara",
    "Meia-noite", "Noite", "Dor", "Pálido", "Navalha", "Cicatriz", "Grito", "Sombra"
];

export const ptSlasherSuffixes = [
    "machado", "lâmina", "sangue", "osso", "garra", "cripta", "corte",
    "morte", "perdição", "pavor", "face", "presa", "medo", "carne", "fantasma",
    "mão", "coração", "gancho", "caçador", "assassino", "faca", "espreita",
    "máscara", "noite", "dor", "ceifador", "estripador", "cicatriz", "grito", "sombra"
];

export const ptCosmicPrefixes = cosmicPrefixes;
export const ptCosmicSuffixes = cosmicSuffixes;

// Arabic Horror Names
export const arDemonPrefixes = [
    "ظلام", "رماد", "دم", "عظم", "قبر", "موت", "رعب", "شبح", "ضريح", "جحيم",
    "لعنة", "أجوف", "شر", "ليل", "نذير", "طيف", "غراب", "وباء", "ظل", "هلاك",
    "عذاب", "سم", "نار", "شيطان", "إبليس", "عفريت", "جن", "مارد", "غول", "سعير"
];

export const arDemonSuffixes = [
    "ائيل", "ار", "مخلب", "شيطان", "موت", "سقوط", "ناب", "نار", "لهب", "دم",
    "جحيم", "قرن", "سوط", "مستنقع", "ظل", "خطيئة", "شوكة",
    "فراغ", "غضب", "بائس", "زار", "زيل", "زور", "زول",
    "هلاك", "عذاب", "فناء", "رعب", "كابوس", "ويل", "ثبور"
];

export const arSlasherPrefixes = [
    "سكين", "دم", "عظم", "جزار", "سلسلة", "مخلب", "ساطور", "بارد", "قبر",
    "قطع", "مظلم", "ميت", "هلاك", "رعب", "حاد", "وجه", "خوف", "لحم",
    "وحشي", "خطاف", "صياد", "قاتل", "سكين", "متربص", "قناع",
    "منتصف الليل", "ليل", "ألم", "شاحب", "شفرة", "ندبة", "صراخ", "ظل"
];

export const arSlasherSuffixes = [
    "فأس", "شفرة", "دم", "عظم", "مخلب", "قبر", "قطع",
    "موت", "هلاك", "رعب", "وجه", "ناب", "خوف", "لحم", "شبح",
    "يد", "قلب", "خطاف", "صياد", "قاتل", "سكين", "متربص",
    "قناع", "ليل", "ألم", "حاصد", "سفاح", "ندبة", "صراخ", "ظل"
];

export const arCosmicPrefixes = cosmicPrefixes;
export const arCosmicSuffixes = cosmicSuffixes;

// Hindi Horror Names
export const hiDemonPrefixes = [
    "अंधकार", "राख", "रक्त", "अस्थि", "कब्र", "मृत्यु", "भय", "प्रेत", "समाधि", "नरक",
    "श्राप", "खोखला", "दुष्ट", "रात", "शकुन", "छाया", "कौवा", "विपत्ति", "अंधेरा", "विनाश",
    "राक्षस", "असुर", "दानव", "पिशाच", "भूत", "वेताल", "चुड़ैल", "डाकिनी", "शाकिनी", "यम"
];

export const hiDemonSuffixes = [
    "असुर", "पंजा", "दानव", "मृत्यु", "पतन", "दाँत", "अग्नि", "ज्वाला", "रक्त",
    "नरक", "सींग", "कोड़ा", "दलदल", "छाया", "पाप", "कांटा",
    "शून्य", "क्रोध", "अभागा", "विनाश", "पीड़ा", "प्रलय", "भय", "दहशत",
    "कालिमा", "अंधकार", "त्रास", "वध", "संहार", "काल"
];

export const hiSlasherPrefixes = [
    "छुरा", "रक्त", "हड्डी", "कसाई", "जंजीर", "पंजा", "कुल्हाड़ी", "ठंडा", "कब्र",
    "काटना", "अंधेरा", "मृत", "विनाश", "भय", "धार", "चेहरा", "डर", "मांस",
    "क्रूर", "हुक", "शिकारी", "हत्यारा", "चाकू", "घात", "मुखौटा",
    "आधी रात", "रात", "दर्द", "पीला", "उस्तरा", "निशान", "चीख", "छाया"
];

export const hiSlasherSuffixes = [
    "कुल्हाड़ी", "धार", "रक्त", "हड्डी", "पंजा", "कब्र", "काट",
    "मृत्यु", "विनाश", "भय", "चेहरा", "दाँत", "डर", "मांस", "भूत",
    "हाथ", "दिल", "हुक", "शिकारी", "हत्यारा", "चाकू", "घात",
    "मुखौटा", "रात", "दर्द", "काल", "चीरने वाला", "निशान", "चीख", "छाया"
];

export const hiCosmicPrefixes = cosmicPrefixes;
export const hiCosmicSuffixes = cosmicSuffixes;

// Japanese Horror Names
export const jaDemonPrefixes = [
    "闇", "灰", "血", "骨", "墓", "死", "恐", "幽", "廟", "獄",
    "呪", "虚", "邪", "夜", "凶", "影", "鴉", "災", "暗", "滅",
    "鬼", "妖", "魔", "怨", "霊", "亡", "冥", "禍", "厄", "黒"
];

export const jaDemonSuffixes = [
    "魔", "爪", "鬼", "死", "堕", "牙", "炎", "獄", "角",
    "影", "罪", "棘", "虚", "怒", "呪", "滅",
    "霊", "闇", "恐", "凶", "邪", "禍", "厄", "惨", "悪", "怨"
];

export const jaSlasherPrefixes = [
    "刃", "血", "骨", "屠", "鎖", "爪", "斧", "冷", "墓",
    "斬", "闇", "死", "凶", "恐", "鋭", "面", "怖", "肉",
    "残", "鉤", "狩", "殺", "刀", "潜", "仮面",
    "深夜", "夜", "痛", "蒼白", "剃刀", "傷", "叫", "影"
];

export const jaSlasherSuffixes = [
    "斧", "刃", "血", "骨", "爪", "墓", "斬",
    "死", "凶", "恐", "面", "牙", "怖", "肉", "幽霊",
    "手", "心", "鉤", "狩人", "殺人", "刀", "潜伏",
    "仮面", "夜", "痛", "死神", "切裂", "傷", "叫", "影"
];

export const jaCosmicPrefixes = cosmicPrefixes;
export const jaCosmicSuffixes = cosmicSuffixes;

// Korean Horror Names
export const koDemonPrefixes = [
    "어둠", "재", "피", "뼈", "무덤", "죽음", "공포", "유령", "묘", "지옥",
    "저주", "공허", "사악", "밤", "흉조", "그림자", "까마귀", "재앙", "암흑", "멸망",
    "귀신", "요괴", "마왕", "원귀", "악령", "사령", "혼령", "망령", "야차", "흑마"
];

export const koDemonSuffixes = [
    "마", "발톱", "귀신", "죽음", "추락", "송곳니", "불", "화염", "피",
    "지옥", "뿔", "채찍", "늪", "그림자", "죄", "가시",
    "공허", "분노", "저주", "멸망", "고통", "파멸", "공포", "전율",
    "어둠", "재앙", "살", "참", "흑", "원"
];

export const koSlasherPrefixes = [
    "칼날", "피", "뼈", "도살", "쇠사슬", "발톱", "도끼", "차가운", "무덤",
    "베기", "어둠", "죽음", "파멸", "공포", "날카로운", "얼굴", "두려움", "살",
    "잔혹", "갈고리", "사냥꾼", "살인", "칼", "잠복", "가면",
    "한밤", "밤", "고통", "창백", "면도날", "흉터", "비명", "그림자"
];

export const koSlasherSuffixes = [
    "도끼", "칼날", "피", "뼈", "발톱", "무덤", "베기",
    "죽음", "파멸", "공포", "얼굴", "송곳니", "두려움", "살", "유령",
    "손", "심장", "갈고리", "사냥꾼", "살인자", "칼", "잠복",
    "가면", "밤", "고통", "사신", "찢는자", "흉터", "비명", "그림자"
];

export const koCosmicPrefixes = cosmicPrefixes;
export const koCosmicSuffixes = cosmicSuffixes;

// Indonesian Horror Names
export const idDemonPrefixes = [
    "Kegelapan", "Abu", "Darah", "Tulang", "Kubur", "Maut", "Horor", "Hantu", "Makam", "Neraka",
    "Kutukan", "Hampa", "Jahat", "Malam", "Pertanda", "Bayangan", "Gagak", "Bencana", "Gelap", "Binasa",
    "Setan", "Iblis", "Raksasa", "Pocong", "Kuntilanak", "Genderuwo", "Sundel", "Tuyul", "Wewe", "Jin"
];

export const idDemonSuffixes = [
    "setan", "cakar", "iblis", "maut", "jatuh", "taring", "api", "kobaran", "darah",
    "neraka", "tanduk", "cambuk", "rawa", "bayangan", "dosa", "duri",
    "hampa", "murka", "kutuk", "binasa", "siksa", "azab", "ngeri", "seram",
    "gelap", "bala", "pembunuh", "pemakan", "penghancur", "pencabut"
];

export const idSlasherPrefixes = [
    "Pisau", "Darah", "Tulang", "Jagal", "Rantai", "Cakar", "Kapak", "Dingin", "Kubur",
    "Potong", "Gelap", "Mati", "Azab", "Ngeri", "Tajam", "Wajah", "Takut", "Daging",
    "Keji", "Kait", "Pemburu", "Pembunuh", "Belati", "Mengintai", "Topeng",
    "Tengah Malam", "Malam", "Sakit", "Pucat", "Silet", "Bekas", "Jeritan", "Bayangan"
];

export const idSlasherSuffixes = [
    "kapak", "pisau", "darah", "tulang", "cakar", "kubur", "potong",
    "maut", "azab", "ngeri", "wajah", "taring", "takut", "daging", "hantu",
    "tangan", "jantung", "kait", "pemburu", "pembunuh", "belati", "pengintai",
    "topeng", "malam", "sakit", "pencabut", "pemotong", "bekas", "jeritan", "bayangan"
];

export const idCosmicPrefixes = cosmicPrefixes;
export const idCosmicSuffixes = cosmicSuffixes;

// Vietnamese Horror Names
export const viDemonPrefixes = [
    "Bóng Tối", "Tro", "Máu", "Xương", "Mộ", "Tử", "Kinh", "Ma", "Miếu", "Địa Ngục",
    "Lời Nguyền", "Rỗng", "Tà", "Đêm", "Điềm", "Bóng", "Quạ", "Tai Ương", "Tối", "Diệt",
    "Quỷ", "Yêu", "Tinh", "Hồn", "Vong", "Âm", "Minh", "Họa", "Ác", "Hắc"
];

export const viDemonSuffixes = [
    "quỷ", "vuốt", "ma", "tử", "rơi", "nanh", "lửa", "hỏa", "máu",
    "ngục", "sừng", "roi", "đầm", "bóng", "tội", "gai",
    "hư không", "nộ", "nguyền", "diệt", "đau", "kiếp", "kinh", "rùng",
    "tối", "ương", "sát", "chém", "hắc", "oán"
];

export const viSlasherPrefixes = [
    "Lưỡi", "Máu", "Xương", "Đồ Tể", "Xích", "Vuốt", "Rìu", "Lạnh", "Mộ",
    "Chém", "Tối", "Chết", "Diệt", "Kinh", "Sắc", "Mặt", "Sợ", "Thịt",
    "Tàn Bạo", "Móc", "Thợ Săn", "Sát Thủ", "Dao", "Rình", "Mặt Nạ",
    "Nửa Đêm", "Đêm", "Đau", "Tái", "Lưỡi Dao", "Sẹo", "Tiếng Hét", "Bóng"
];

export const viSlasherSuffixes = [
    "rìu", "lưỡi", "máu", "xương", "vuốt", "mộ", "chém",
    "tử", "diệt", "kinh", "mặt", "nanh", "sợ", "thịt", "ma",
    "tay", "tim", "móc", "thợ săn", "sát thủ", "dao", "rình",
    "mặt nạ", "đêm", "đau", "tử thần", "đao phủ", "sẹo", "hét", "bóng"
];

export const viCosmicPrefixes = cosmicPrefixes;
export const viCosmicSuffixes = cosmicSuffixes;

// Russian Horror Names
export const ruDemonPrefixes = [
    "Тьма", "Пепел", "Кровь", "Кость", "Склеп", "Смерть", "Ужас", "Призрак", "Гроб", "Ад",
    "Проклятие", "Пустота", "Злой", "Ночь", "Зловещий", "Тень", "Ворон", "Бич", "Мрак", "Погибель",
    "Демон", "Бес", "Упырь", "Вурдалак", "Навь", "Морок", "Лихо", "Кикимора", "Леший", "Кощей"
];

export const ruDemonSuffixes = [
    "амон", "ар", "коготь", "демон", "смерть", "падение", "клык", "огонь", "пламя", "кровь",
    "ад", "рог", "плеть", "болото", "тень", "грех", "шип",
    "пустота", "гнев", "проклятый", "погибель", "мука", "кара", "ужас", "жуть",
    "мрак", "бич", "убийца", "пожиратель", "разрушитель", "мор"
];

export const ruSlasherPrefixes = [
    "Лезвие", "Кровь", "Кость", "Мясник", "Цепь", "Коготь", "Топор", "Холод", "Склеп",
    "Рез", "Тьма", "Мертвый", "Гибель", "Ужас", "Острый", "Лицо", "Страх", "Плоть",
    "Жестокий", "Крюк", "Охотник", "Убийца", "Нож", "Засада", "Маска",
    "Полночь", "Ночь", "Боль", "Бледный", "Бритва", "Шрам", "Крик", "Тень"
];

export const ruSlasherSuffixes = [
    "топор", "лезвие", "кровь", "кость", "коготь", "склеп", "рез",
    "смерть", "гибель", "ужас", "лицо", "клык", "страх", "плоть", "призрак",
    "рука", "сердце", "крюк", "охотник", "убийца", "нож", "засада",
    "маска", "ночь", "боль", "жнец", "потрошитель", "шрам", "крик", "тень"
];

export const ruCosmicPrefixes = cosmicPrefixes;
export const ruCosmicSuffixes = cosmicSuffixes;

// Italian Horror Names
export const itDemonPrefixes = [
    "Cenere", "Sangue", "Osso", "Cripta", "Morte", "Tenebre", "Terrore", "Spettro", "Tomba", "Inferno",
    "Maledizione", "Vuoto", "Malvagio", "Notte", "Presagio", "Ombra", "Corvo", "Flagello", "Oscuro", "Rovina",
    "Demone", "Diavolo", "Strega", "Vampiro", "Lupo Mannaro", "Fantasma", "Spettro", "Mostro", "Bestia", "Maligno"
];

export const itDemonSuffixes = [
    "amon", "ar", "artiglio", "demone", "morte", "caduta", "zanna", "fuoco", "fiamma", "sangue",
    "inferno", "corno", "frusta", "palude", "ombra", "peccato", "spina",
    "vuoto", "ira", "maledetto", "rovina", "tormento", "castigo", "terrore", "orrore",
    "oscuro", "flagello", "assassino", "divoratore", "distruttore", "peste"
];

export const itSlasherPrefixes = [
    "Lama", "Sangue", "Osso", "Macellaio", "Catena", "Artiglio", "Ascia", "Freddo", "Cripta",
    "Taglio", "Oscuro", "Morto", "Rovina", "Terrore", "Affilato", "Volto", "Paura", "Carne",
    "Crudele", "Gancio", "Cacciatore", "Assassino", "Coltello", "Agguato", "Maschera",
    "Mezzanotte", "Notte", "Dolore", "Pallido", "Rasoio", "Cicatrice", "Urlo", "Ombra"
];

export const itSlasherSuffixes = [
    "ascia", "lama", "sangue", "osso", "artiglio", "cripta", "taglio",
    "morte", "rovina", "terrore", "volto", "zanna", "paura", "carne", "fantasma",
    "mano", "cuore", "gancio", "cacciatore", "assassino", "coltello", "agguato",
    "maschera", "notte", "dolore", "mietitore", "squartatore", "cicatrice", "urlo", "ombra"
];

export const itCosmicPrefixes = cosmicPrefixes;
export const itCosmicSuffixes = cosmicSuffixes;

// Polish Horror Names
export const plDemonPrefixes = [
    "Ciemność", "Popiół", "Krew", "Kość", "Krypta", "Śmierć", "Groza", "Widmo", "Grób", "Piekło",
    "Klątwa", "Pustka", "Zło", "Noc", "Omen", "Cień", "Kruk", "Plaga", "Mrok", "Zguba",
    "Demon", "Diabeł", "Upiór", "Strzyga", "Wampir", "Licho", "Zmora", "Utopiec", "Bies", "Czart"
];

export const plDemonSuffixes = [
    "amon", "ar", "szpon", "demon", "śmierć", "upadek", "kieł", "ogień", "płomień", "krew",
    "piekło", "róg", "bicz", "bagno", "cień", "grzech", "cierń",
    "pustka", "gniew", "przeklęty", "zguba", "męka", "kara", "groza", "zgroza",
    "mrok", "plaga", "zabójca", "pożeracz", "niszczyciel", "pomór"
];

export const plSlasherPrefixes = [
    "Ostrze", "Krew", "Kość", "Rzeźnik", "Łańcuch", "Szpon", "Topór", "Zimno", "Krypta",
    "Cięcie", "Ciemność", "Martwy", "Zguba", "Groza", "Ostry", "Twarz", "Strach", "Ciało",
    "Okrutny", "Hak", "Łowca", "Zabójca", "Nóż", "Czatownik", "Maska",
    "Północ", "Noc", "Ból", "Blady", "Brzytwa", "Blizna", "Krzyk", "Cień"
];

export const plSlasherSuffixes = [
    "topór", "ostrze", "krew", "kość", "szpon", "krypta", "cięcie",
    "śmierć", "zguba", "groza", "twarz", "kieł", "strach", "ciało", "widmo",
    "ręka", "serce", "hak", "łowca", "zabójca", "nóż", "czatownik",
    "maska", "noc", "ból", "żniwiarz", "rozpruwacz", "blizna", "krzyk", "cień"
];

export const plCosmicPrefixes = cosmicPrefixes;
export const plCosmicSuffixes = cosmicSuffixes;

// Dutch Horror Names
export const nlDemonPrefixes = [
    "Duisternis", "As", "Bloed", "Bot", "Crypte", "Dood", "Gruwel", "Geest", "Graf", "Hel",
    "Vloek", "Leeg", "Kwaad", "Nacht", "Onheil", "Schaduw", "Raaf", "Plaag", "Donker", "Verderf",
    "Demon", "Duivel", "Spook", "Vampier", "Weerwolf", "Heks", "Lijk", "Monster", "Beest", "Boze"
];

export const nlDemonSuffixes = [
    "amon", "ar", "klauw", "demon", "dood", "val", "tand", "vuur", "vlam", "bloed",
    "hel", "hoorn", "zweep", "moeras", "schaduw", "zonde", "doorn",
    "leegte", "toorn", "vervloekt", "verderf", "kwelling", "straf", "gruwel", "afschuw",
    "donker", "plaag", "moordenaar", "verslinder", "vernietiger", "pest"
];

export const nlSlasherPrefixes = [
    "Lemmet", "Bloed", "Bot", "Slager", "Ketting", "Klauw", "Bijl", "Koud", "Crypte",
    "Snij", "Duister", "Dood", "Verderf", "Gruwel", "Scherp", "Gezicht", "Angst", "Vlees",
    "Wreed", "Haak", "Jager", "Moordenaar", "Mes", "Loer", "Masker",
    "Middernacht", "Nacht", "Pijn", "Bleek", "Scheermes", "Litteken", "Schreeuw", "Schaduw"
];

export const nlSlasherSuffixes = [
    "bijl", "lemmet", "bloed", "bot", "klauw", "crypte", "snij",
    "dood", "verderf", "gruwel", "gezicht", "tand", "angst", "vlees", "geest",
    "hand", "hart", "haak", "jager", "moordenaar", "mes", "loer",
    "masker", "nacht", "pijn", "maaier", "ripper", "litteken", "schreeuw", "schaduw"
];

export const nlCosmicPrefixes = cosmicPrefixes;
export const nlCosmicSuffixes = cosmicSuffixes;
